import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Register service worker after initial paint to avoid blocking FCP
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Delay SW registration until after paint
    requestIdleCallback?.(() => {
      navigator.serviceWorker.register('/sw.js', { scope: '/' })
        .catch(() => {
          // Silently fail - SW registration is optional
        });
    }) ?? setTimeout(() => {
      navigator.serviceWorker.register('/sw.js', { scope: '/' })
        .catch(() => {
          // Silently fail - SW registration is optional
        });
    }, 1000);
  });
}
